
import { ArrowCircleRightSharp } from '@mui/icons-material';
import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import Scroll from 'react-scroll';
import ConnUrls from '../Connections/ConnectURL';
import { TheOrderContext } from '../Contexts/TheOrder_Context';
import { MasterContext } from '../Contexts/Master_Context';
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import OrederApprovedPop from '../PopUps/OrederApprovedPop';
import PopUpClearComp from '../PopUps/PopUpClearComp';

var scroller = Scroll.scroller;
var scroll = Scroll.animateScroll;

const ThankPage = (props) => {

  const currentUrl = window.location.href;
  const urlObject = new URL(currentUrl);
  const domain = urlObject.origin;

  const { theOrder, setTheOrder, addToTheOrder, updateTheOrd } = useContext(TheOrderContext);
  const [master, setMaster] = useContext(MasterContext);

  const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
  const [loading, setLoading] = useState(true);
  const [waitImgItm, setWaitImgItm] = useState({});
  const [bkparams, setBkparams] = useState();
  const [thePopUp, setThePopUp] = useState("");


  const navigate = useNavigate();
  const params = useParams();

  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  }

  useEffect(() => {

    // props.shoTopStrp(false)
    // getSinglePage();
    let bkPrms = getParmeters();
    setThePopUp();


    setThePopUp(
      <PopUpClearComp BtnTxt={"סגור"}
        title={""}
        noCloseBtn={true}
        noLineStart={true}
        btnFStyle={"fatInBtn"}
        closePop={() => setThePopUp()}
        parentCLose={() => props.parentCLose()}
        theInsideComp={
          <OrederApprovedPop
            backFunc={true}
            theHelloTxt={"אישור ההזמנה"}
            closeMeFuc={() => setThePopUp()}
            parentCLose={() => setThePopUp()()}
            order={bkPrms}
            scrollToTop={(stUp) => { }}
            connectWithNumber={() => { setThePopUp(); }}
          />
        } />
    )

    setLoading(false);


  }, [])

  const goOutsidOfframe = () => {
    if (window.parent !== window) {

      // Access the parent window's history object and push the new state
      window.parent.location.href = '/MyOrders';
    } else {
      setThePopUp();
      // If not inside an iframe, use the regular history.push
      navigate("/");
    }

  }


  const getParmeters = async () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (urlParams) {
      let prms = {
        orderNumber: urlParams.get('orderNumber'),
        transactionId: urlParams.get('transactionId'),
      }

      theOrder.orderNUM = urlParams.get('orderNumber');
      theOrder.creditCrdApprov = urlParams.get('transactionId');

      setBkparams(prms);

      return {
        orderNUM: theOrder.orderNUM,
        paymentStatus: theOrder.creditCrdApprov
      };
    }
    else {
      navigate("/404")
    }
  }

  const goToBack = () => {

    navigate.goBack();

  }

  const setBackground = () => {

    if (window.parent !== window) {
      const elements = document.querySelectorAll('.popDiagBlock > div');

      elements.forEach((element) => {
        element.style.backgroundColor = 'white';
      });

      const inelements = document.querySelectorAll('.popDiagBlock .MuiPaper-root');

      inelements.forEach((element) => {
        element.style.boxShadow = 'unset';
      });
    }
  }

  return (
    <div className="SinglePage">
      <div className={loading ? "imgWaiting" :
        `imgWaiting animate__animated animate__fast animate__zoomOut ${waitImgItm.imgDelay}`}
        style={{
          backgroundImage: `url(${ConnUrls.servMediasUrl}${waitImgItm.waitImg})`,
          backgroundPosition: `${waitImgItm.imgBackPos}`,
          backgroundSize: `${(!mobiOrNot) ? "25%" : waitImgItm.backgroundSize}`,
          backgroundRepeat: `${waitImgItm.backgroundRepeat}`
        }}>
      </div>

      {loading ? "" :
        <>
          {(mobiOrNot) ?
            <>
              <div className={"headOnFixC SecondFont bold big"}>
                {/* <div className={`backSd`}>
                  <ArrowCircleRightSharp onClick={() => goToBack()} />
                </div> */}
              </div>
              <div className={`singlePagePad`}>
              </div>
            </>
            :
            ""

          }

          {thePopUp}
          {setBackground()}
        </>

      }

    </div>
  );
}

export default ThankPage;
